<template>
       <section class="text-center" >
        <div class="container section-content" id="contact"  style="margin-bottom: 300px">

          
            <a href="mailto:kwamekert@gmail.com" class="btn btn-outline-primary social-buttons"><img src="@/assets/img/simplemail.svg" width="30px" height="30px" alt="" class="pt-2"> &nbsp;&nbsp;<p class="m-2">Lets chat.</p></a>

            <a href="https://github.com/KwameKert" target="blank" class="btn btn-outline-primary social-buttons"> 
            <img src="@/assets/img/github.svg" width="30px" height="30px" alt="" class="pt-2">
            &nbsp;&nbsp;<p class="m-2"> Star my repos </p></a>
            <a href="https://www.linkedin.com/in/kertice-asante-aa4224173/" target="blank" class="btn btn-outline-primary social-buttons"> <img src="@/assets/img/linkedin.svg" alt="" class="pb-1">  &nbsp;&nbsp; <p class="m-2">Connect with me</p></a>
            <a href="https://twitter.com/_kwamekert" target="blank" class="btn btn-outline-primary social-buttons"> <img src="@/assets/img/twitter.svg" alt="" class="pt-1">  &nbsp;&nbsp; <p class="m-2">Follow me</p></a>

        </div>
        </section>
</template>

<script>
export default {
   name: 'Contact'
}
</script>

<style >

 a{
        margin: 20px;
        display: inline-flex !important;
    }

   p{
    color: #b7babd;
}
    
</style>